import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className='footerzim'>
      Animedex project to PWEB2.<br></br>
      Issues? Repository on <a href="https://www.github.com/iamjunioru/animedex" target="_blank" className='gitlink'>Github</a>.  
    </footer>
  );
}
